import React from 'react'
import { times } from 'lodash-es'

import { TtIcon } from '@23/ui-react'

import './FocusPreviewTraySpeakers.scss'

const FocusPreviewTraySpeakers = () => {
  return (
    <div className="focus-preview-tray-speakers">
      {times(5, (idx) => (
        <div key={idx} className="focus-preview-tray-speakers-item">
          <TtIcon library="one/webinars" name="speaker" />
        </div>
      ))}
    </div>
  )
}

export { FocusPreviewTraySpeakers }
